
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("Y851Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2506eca36315c13b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $2506eca36315c13b$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "A\xf1ade tu propio emoji",
    'fabric.emoji.add.label': "A\xf1adir emoji",
    'fabric.emoji.cancel.label': 'Cancelar',
    'fabric.emoji.categories.label': "Elige una categor\xeda de emojis",
    'fabric.emoji.categories.search.results': "Resultados de b\xfasqueda",
    'fabric.emoji.category.activity': 'Actividades',
    'fabric.emoji.category.all.uploads': 'Todos los elementos subidos',
    'fabric.emoji.category.flags': 'Banderas',
    'fabric.emoji.category.foods': 'Comida y bebida',
    'fabric.emoji.category.frequent': 'Frecuentes',
    'fabric.emoji.category.nature': 'Naturaleza',
    'fabric.emoji.category.objects': 'Objetos',
    'fabric.emoji.category.people': 'Personas',
    'fabric.emoji.category.places': 'Viajes y lugares',
    'fabric.emoji.category.productivity': 'Productividad',
    'fabric.emoji.category.symbols': "S\xedmbolos",
    'fabric.emoji.category.user.uploads': 'Tus elementos subidos',
    'fabric.emoji.choose.file.screenReaderDescription': "Elige un archivo para el emoji. JPG, PNG o GIF. Tama\xf1o m\xe1ximo de 1\xa0MB.",
    'fabric.emoji.choose.file.title': 'Elegir archivo',
    'fabric.emoji.delete.description': "Todos los registros que existan de este emoji se sustituir\xe1n por {emojiShortName}",
    'fabric.emoji.delete.label': 'Eliminar',
    'fabric.emoji.delete.screenreader.tooltip': 'Para eliminar un emoji de {shortName}, pulsa la tecla de retroceso',
    'fabric.emoji.delete.title': 'Eliminar emoji',
    'fabric.emoji.delete.tooltip': 'Eliminar',
    'fabric.emoji.emojipicker.emoi.roledescription': "bot\xf3n de emoji",
    'fabric.emoji.emojipicker.error': "\xa1Error!",
    'fabric.emoji.error.delete.failed': "Error de eliminaci\xf3n",
    'fabric.emoji.error.image.too.big': "La imagen seleccionada ocupa m\xe1s de 1\xa0MB",
    'fabric.emoji.error.invalid.image': "La imagen seleccionada no es v\xe1lida",
    'fabric.emoji.error.upload.failed': 'Error de subida',
    'fabric.emoji.error.upload.timeout': 'Se ha agotado el tiempo de carga',
    'fabric.emoji.image.requirements': "JPG, PNG o GIF de 1\xa0MB como m\xe1ximo.",
    'fabric.emoji.name.ariaLabel': 'Introducir un nombre para el nuevo emoji',
    'fabric.emoji.picker': 'Selector de emojis',
    'fabric.emoji.pickerlist.grid': "{showSearchResults, select, true {Resultados de b\xfasqueda} other {Emoticonos}}",
    'fabric.emoji.pickerlist.tabpanel': 'Panel de acciones y listas de emojis',
    'fabric.emoji.placeholder': 'Por ejemplo: hola',
    'fabric.emoji.preview': 'El emoji nuevo {emoji} es genial',
    'fabric.emoji.preview.title': 'Vista previa',
    'fabric.emoji.retry.label': 'Volver a intentarlo',
    'fabric.emoji.search.label': 'Nombre del emoji',
    'fabric.emoji.search.placeholder': 'Buscar',
    'fabric.emoji.search.status': 'Viendo todos los emojis',
    'fabric.emoji.select.skin.list.ariaLabel': 'Selector de tonos de piel',
    'fabric.emoji.select.skin.tone.ariaLabel': 'Elige tu tono de piel (tono seleccionado: {selectedTone})'
};

});


//# sourceMappingURL=es.b7fedce0.js.map
